/** Removes the pre-React HTML shell shown on cold hotel-details tab opens. */
export const clearHotelDetBootstrapLoader = () => {
  if (typeof window === "undefined") {
    return;
  }
  if (typeof window.__clearHotelDetBootstrapLoader === "function") {
    window.__clearHotelDetBootstrapLoader();
    return;
  }
  const el = document.getElementById("hotel-det-bootstrap-loader");
  if (el) {
    el.remove();
  }
};
